module.exports = __webpack_public_path__ + "static/media/bh.93ac9346.webp";